var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-desc-group c:col-center-stretch",style:({
    '--padding-y': _vm.computedPaddingY,
    '--item-gap': _vm.computedItemGap,
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }